import React from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Image, Row, Space, Table, Tag } from "antd";
import useLanguage from "../hooks/useLanguage";
import { useLoad } from "../hooks/request";
import { cardDelete, cardList } from "../utils/url";
import EditDrawerBtn from "../components/Atoms/Buttons/EditDrawerBtn";
import DeleteModalBtn from "../components/Atoms/Buttons/DeleteModalBtn";
import PostDrawerBtn from "../components/Atoms/Buttons/PostDrawerBtn";
import StatusTag from "../components/Atoms/StatusTag/StatusTag";
import { useGetTitle } from "../hooks/useGetTitle";

const CardsPage = () => {
  const { translateTitle } = useGetTitle();
  const getRequest = useLoad({ url: cardList });
  const { response, loading } = getRequest;
  const translate = useLanguage();

  const columns = [
    {
      title: "Image",
      dataIndex: "icon",
      render: (record) => (
        <Row align="middle" justify="center" style={{ width: 60, height: 50 }}>
          <Image
            width="100%"
            height="100%"
            src={record}
            alt="image"
            style={{ objectFit: "cover" }}
          />
        </Row>
      ),
    },
    {
      title: "Title",
      dataIndex: translateTitle("title"),
      key: "title",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 120,
      render: (value) => (
        <Tag color={value === "payment" ? "gold" : "blue"} bordered={false}>
          {value || "redirect"}
        </Tag>
      ),
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      ellipsis: true,
      responsive: ["lg"],
      render: (value) =>
        value ? (
          <a href={value} target="_blank" rel="noreferrer">
            {value}
          </a>
        ) : (
          "—"
        ),
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
      width: 90,
      responsive: ["md"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (value) => <StatusTag value={value} />,
    },
    {
      title: "",
      key: "actions",
      width: 200,
      render: (_, record) => (
        <Space className="crud__actions">
          <EditDrawerBtn
            type={"cards"}
            data={record}
            request={getRequest.request}
          />
          <DeleteModalBtn
            url={cardDelete}
            id={record._id}
            request={getRequest.request}
          />
        </Space>
      ),
    },
  ];

  return (
    <section className="page">
      <header className="page__header">
        <h1 className="page__title">Cards</h1>
        <PostDrawerBtn type={"cards"} request={getRequest.request}>
          <AiOutlinePlusCircle className="icon" />
          {translate("add-cards")}
        </PostDrawerBtn>
      </header>
      <div className="page__content">
        <Table
          columns={columns}
          dataSource={response?.data?.cards?.cards}
          scroll={{ x: "max-content" }}
          pagination={{
            pageSize: 10,
            total: response?.data?.cards?.pagination?.total,
            onChange: (page) => {
              getRequest.request({
                url: `${cardList}?page=${page}&size=10`,
              });
            },
          }}
          loading={loading}
          rowKey="id"
        />
      </div>
    </section>
  );
};

export default CardsPage;
